import type { FaireProductEntity } from "../../entity_types/product";

export const p_p73p6djwwh: FaireProductEntity = {
  token: "p_p73p6djwwh",
  type: "product",
  name: "Only When Tee",
  brandToken: "b_557ocq7k0h",
  brandName: "Allegheny Outfitters",
  imageUrl:
    "https://cdn.faire.com/fastly/4e90b67951dee6437f995672eec40e3608b35b6ef9c33b29099bc0306e775899.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2b21bb037fbf1bf548966b42eb744515526993fd7129eee95493ee0b987fb17c.jpeg",
    "https://cdn.faire.com/fastly/630d1133bd1eb09bb1111a6d67a47dbd9b9fdec71dc3281356c9afa8fc74ecc8.jpeg",
    "https://cdn.faire.com/fastly/f8bb340a8687d4ffaee44c1a4ba2fec5118f3d95225ddbfb3ef15975ab240281.jpeg",
    "https://cdn.faire.com/fastly/99335ef4542fb19ab43c5be172157e4301cca532de1839d5c77d3347d2608811.jpeg",
  ],
  priceDollars: 20.09,
  description:
    "A Native American proverb, often attributed to the Cree people, emphasizing the importance of environmental preservation and the interconnectedness of nature and human well-being. Only when the last tree has been cut down, the last fish caught, and the last stream poisoned, will we realize we cannot eat money.\n\nPrinted in house on super comfy shirts you'll want to wear.",
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:26.563Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
